import { createRoot } from 'react-dom/client'
import './style/main.css'
import App from './App.jsx'

createRoot(document.getElementById('root')).render(<App />)
